import $ from 'jquery'
import dayjs from 'dayjs'

import scroll from 'garden/src/js/utils/scroll'
import emitter from 'garden/src/js/utils/emitter'

import BaseComponent from 'scripts/components/base-component'
import { showSpinner, hideSpinner } from 'scripts/utils/spinner'
import tokenNotify from 'scripts/utils/account/token-notifier'
import Alert from 'scripts/utils/alert'
import { dispatchLoginToDataLayer, pushDataObject } from 'scripts/utils/data-layer'

class SignUp extends BaseComponent {
  static componentName = 'sign-up'

  static DOMEvents = {
    submit: 'onFormSubmit',
    'click [data-loyalty-optin]': 'onOptinLoyalty',
    'click [data-loyalty-pro-optin]': 'onOptinLoyalty'
  }

  static emitterEvents = {
    'validation:success': 'onValidateSuccess',
    'validation:error': 'onValidateWarning',
    'recaptcha:success': 'submitForm'
  }

  init () {
    this.$feedbackWarning = $('[data-feedback-warning]')
    this.$feedbackSuccess = $('[data-feedback-success]')
    this.$notRegistered = $('[data-not-registered]')
    this.$documentNumber = this.$element.find('[data-document-number]')
    this.$redirect = $('[data-response-redirect]', this.$feedbackSuccess)
    this.$loyaltyOptin = $('[data-loyalty-optin]')
    this.$loyaltyProOptin = $('[data-loyalty-pro-optin]')
    this.$loyaltyForm = $('[data-loyalty-form]')
    this.$loyaltyProForm = $('[data-loyalty-pro-form]')
    this.$loyaltyInputs = $('[data-loyalty-inputs]')
    this.$loyaltyProInputs = $('[data-loyalty-pro-inputs]')
    this.$loyaltyBirthdate = $('[data-loyalty-birthdate]')
    this.scroll = scroll
  }

  onOptinLoyalty (event) {
    const optin = $(event.currentTarget)

    if (optin.attr('name') === 'loyalty_program_pro') {
      return this.toggleFormLoyalty(optin.is(':checked'), this.$loyaltyProInputs, this.$loyaltyProForm)
    }

    return this.toggleFormLoyalty(optin.is(':checked'), this.$loyaltyInputs, this.$loyaltyForm)
  }

  toggleFormLoyalty (optin, inputs, form) {
    Array.prototype.forEach.call(
      inputs,
      (field) => emitter.emit('validation:pristine', field)
    )

    if (optin) {
      inputs
        .attr('data-required', true)
        .attr('data-validate', 'required')

      return form.slideDown()
    }

    inputs
      .removeAttr('data-required')
      .removeAttr('data-validate')

    Array.prototype.forEach.call(
      inputs,
      (field) => {
        const isRadio = $(field).attr('type') === 'radio'
        isRadio ? $(field).prop('checked', false) : $(field).val('')
      }
    )

    return form.slideUp()
  }

  onWarningBirthDate () {
    const message = $('<span>')
      .addClass('loyalty-date-invalid')
      .html('É necessário ter mais de 18 anos para participar do programa de fidelidade Leroy Merlin com você')

    $('[data-helper="birthdate"]').html(message)
  }

  onSuccessBirthDate () {
    const message = $('<span>')
      .html('É necessário ter mais de 18 anos para participar do programa de fidelidade Leroy Merlin com você')

    $('[data-helper="birthdate"]').html(message)
  }

  isMinAgeToAgree () {
    if (!this.$loyaltyOptin.is(':checked')) {
      return true
    }

    const formatBirth = this.$loyaltyBirthdate.val().replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1')
    const birthdate = dayjs(formatBirth)
    const now = dayjs()

    return (now.diff(birthdate, 'year') >= 18)
  }

  getFormValidation () {
    if (!this.validation) {
      this.validation = this.$element.validation().data('validation')
    }
  }

  onFormSubmit (event) {
    event.preventDefault()
    this.getFormValidation()

    if (!this.validation.validateAll()) {
      return this.scrollTop()
    }

    if (!this.isMinAgeToAgree()) {
      this.onWarningBirthDate()
      return this.scrollTop()
    }

    showSpinner()

    if (this.$element.data('recaptchaDisabled') === 1) {
      return this.submitForm()
    }

    emitter.emit('recaptcha:execute')
  }

  onValidateWarning (input) {
    this.toggleMessage(input, 'warning')
  }

  onValidateSuccess (input) {
    if (this.$loyaltyBirthdate.is(input)) {
      this.onSuccessBirthDate()

      if (!this.isMinAgeToAgree()) {
        this.onWarningBirthDate()
        return false
      }
    }

    this.toggleMessage(input, 'success')
  }

  toggleMessage (input, type) {
    const $input = $(input)
    const $field = $input.closest('.field')
    const target = $input.data('validate-target')
    const message = $input.data(`validate-${type}`)

    if (type === 'warning') {
      $field.removeClass('valid').addClass('invalid')
    } else if (type === 'success') {
      $field.removeClass('invalid').addClass('valid')
    }

    $(target).html(message)
  }

  submitForm () {
    const action = this.$element.attr('action')
    const data = this.$element.serialize()

    if (this.$element.hasClass('hidden')) {
      return
    }

    $.post(action, data, 'json')
      .done(this.onSubmitSuccess.bind(this))
      .fail((response) => {
        emitter.emit('recaptcha:submit-error')
        this.onSubmitWarning(response)
      })
      .always(this.scrollTop())
  }

  onSubmitSuccess (response) {
    const dataObject = dispatchLoginToDataLayer(response)

    hideSpinner()

    if (response.status !== 'success') {
      return console.error(response)
    }

    pushDataObject(dataObject)

    if (response.needDocumentation) {
      return this.toggleDocumentSend()
    }

    tokenNotify()

    if (response.redirect) {
      this.$redirect.attr('href', response.redirect)
    }

    this.showFeedbackSuccess()
  }

  onSubmitWarning (response) {
    hideSpinner()

    let errors

    if (response.responseJSON && response.responseJSON.errors) {
      errors = response.responseJSON.errors
    } else {
      errors = {
        error: ['Por favor, tente novamente mais tarde.']
      }
    }

    const $response = this.$feedbackWarning.find('.response')

    $response.html('')

    $.each(errors, (key, val) => {
      val.map(message => $response.append(`${message}<br>`))
    })

    this.showFeedbackWarning()
  }

  showFeedbackWarning () {
    this.hideFeedbackSuccess()
    this.$feedbackWarning.removeClass('hidden')
  }

  hideFeedbackWarning () {
    this.$feedbackWarning.addClass('hidden')
  }

  showFeedbackSuccess () {
    this.hideFields()
    this.hideFeedbackWarning()
    $('[data-form-type]').addClass('hidden')
    this.$notRegistered.addClass('hidden')
    this.$feedbackSuccess.removeClass('hidden')
  }

  hideFeedbackSuccess () {
    this.$feedbackSuccess.addClass('hidden')
  }

  hideFields () {
    this.$element.find('[data-hide-on-success]').addClass('hidden')
  }

  scrollTop () {
    this.scroll($('body'), { offset: -120 })
  }

  redirectLoyalty () {
    location.href = '/fidelidade'
  }

  toggleDocumentSend () {
    emitter.emit('loyalty-pro:open', {
      occupation: document.querySelector('[data-loyalty-pro-occupation]').value,
      onFinish: this.redirectLoyalty,
      onCancel: this.redirectLoyalty
    })
  }
}

export default ($el) => new SignUp($el).init()

export { SignUp as Component }
